import http from "app/services/httpService";
import config from "config.json";

const { apiUrl } = config;

// Get data from api
const getApiUserGroup = async (queryString) => {
  try {
    const url = `${apiUrl}/apiusergroups${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
//Post data to api
const addApiUserGroup = async (req) => {
  try {
    const url = `${apiUrl}/apiusergroups`;
    const { data } = await http.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};
//Get data for Edit
const getApiUserGroupforEdit = async () => {
  try {
    const url = `${apiUrl}/apiusergroups`;
    const { data } = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
//For Update data

const deleteUserGroup = async (id) => {
  try {
    const url = `${apiUrl}/apiusergroups/${id}`;
    const { data } = await http.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getTagMarkup = async () => {
  try {
    const url = `${apiUrl}/usergroups/tagmarkup`;
    const { data } = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getCommissionMarkup = async () => {
  try {
    const url = `${apiUrl}/usergroups/commissionmarkup`;
    const { data } = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateApi = async (value) => {
  try {
    const url = `${apiUrl}/apiusergroups/update-apiuser`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  getApiUserGroup,
  addApiUserGroup,
  getApiUserGroupforEdit,
  deleteUserGroup,
  getTagMarkup,
  getCommissionMarkup,
  updateApi,
};
